import React, { useEffect, useRef, useState } from 'react';
import { Box, CircularProgress, Collapse, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { yupResolver } from '@hookform/resolvers/yup';

import { useForm } from 'react-hook-form';
import { instanceAxios } from '../../../../InstanceAxios';

import useFetch from '../../../../hooks/useFetch';
import { useAlert } from '../../../../hooks/useAlert';
import { getCardValues } from './utils';

import { Input, InputMask } from '../../../../components/Form';

import {
  CVC_PATTERN,
  DATA_VENCIMENTO_CARTAO,
} from '../../../../consts/patterns';

import { Container } from '../../../../components/Layouts/Container';
import { Button } from '../../../../components/Layouts/Button';
import {
  Centered,
  Title,
} from '../../../../components/Layouts/Container/styles';

import schema from './schema';
import { CardInput } from '../../components/CardInput';
import SuperModal from '../../../../components/SumperModal';

const defaultFormValues = {
  holder_name: '',
  display_number: '',
  expiration_date: '',
  cvv: '',
};

function MeiosPagamento() {
  const userId = localStorage.getItem('idadmin');

  const { isLoading, data, refetch } = useFetch(`/cartaoCredito?id=${userId}`);

  const { alert, openAlert, closeAlert } = useAlert();

  const modalRef = useRef(null);

  const [isUpdate, setIsUpdate] = useState(false);
  const [formSubmiting, setFormSubmiting] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(schema),
  });

  // atualiza os dados do cartão quando a requisicao é concluida
  useEffect(() => {
    if (data?.data && data.data?.month && data.data?.month) {
      const { month, year } = data.data;

      setIsUpdate(true);

      reset({
        ...data.data,
        expiration_date: `${month < 10 ? `0${month}` : month}/${year}`,
      });
    } else {
      reset(defaultFormValues);
    }
  }, [data, reset]);

  const handleSalvarCartao = async (formData) => {
    try {
      setFormSubmiting(true);

      const token = localStorage.getItem('toobiauth');

      const cardValues = getCardValues(formData);

      await instanceAxios(token).post('/cartaoCredito', {
        id_usuario: userId,
        ...cardValues,
      });

      refetch();

      setIsUpdate(true);

      openAlert('Cartão salvo com sucesso!');
    } catch (error) {
      openAlert(
        `Falha ao tentar salvar o cartão!${
          error?.response?.data?.message &&
          ` - ${error?.response?.data?.message}`
        }`,
        'error'
      );
    } finally {
      setFormSubmiting(false);
    }
  };

  const handleRemoverCartao = async () => {
    try {
      setFormSubmiting(true);

      const token = localStorage.getItem('toobiauth');

      await instanceAxios(token).delete('/cartao/remover');

      reset(defaultFormValues);

      setIsUpdate(false);

      openAlert('Cartão removido com sucesso!');
    } catch (error) {
      openAlert('Falha ao tentar remover o cartão!', 'error');
    } finally {
      setFormSubmiting(false);
    }
  };

  return (
    <Container isLoading={isLoading} maxwidth={600}>
      <Collapse in={alert.open}>
        <Alert severity={alert.severity} onClick={closeAlert}>
          {alert.message}
        </Alert>
      </Collapse>
      <SuperModal
        ref={modalRef}
        title="VOCÊ TEM CERTEZA?"
        description="Você não poderá recuperar o cartão após a remoção."
        onConfirm={handleRemoverCartao}
      />
      <Title>Dados de pagamento</Title>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Input
            control={control}
            id="holder_name"
            name="holder_name"
            label="Titular do cartão"
            error={!!errors?.holder_name}
            helperText={errors?.holder_name ? errors.holder_name.message : ''}
            variant="outlined"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12}>
          <CardInput
            control={control}
            id="display_number"
            name="display_number"
            label="Número do cartão"
            error={!!errors?.display_number}
            cardBrand={data?.data?.brand}
            helperText={
              errors?.display_number ? errors.display_number.message : ''
            }
            variant="outlined"
            isDisplay={isUpdate}
            fullWidth
            disabled={isUpdate}
          />
        </Grid>
        <Grid item xs={6}>
          <InputMask
            control={control}
            id="expiration_date"
            name="expiration_date"
            label="Validade"
            pattern={DATA_VENCIMENTO_CARTAO}
            placeholder="MM/AA"
            error={!!errors?.expiration_date}
            helperText={
              errors?.expiration_date ? errors.expiration_date.message : ''
            }
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <InputMask
            control={control}
            id="cvv"
            name="cvv"
            label="CVV"
            placeholder="CVV"
            pattern={CVC_PATTERN}
            error={!!errors?.cvv}
            helperText={errors?.cvv ? errors.cvv.message : ''}
            variant="outlined"
            fullWidth
          />
        </Grid>
      </Grid>
      <Centered>
        <Box marginTop={4}>
          {formSubmiting ? (
            <Button size="medium" variant="contained" color="primary" disabled>
              <CircularProgress color="primary" size={25} />
            </Button>
          ) : isUpdate ? (
            <Button
              size="medium"
              variant="contained"
              color="secondary"
              marginleft={10}
              onClick={() => modalRef.current?.open()}
            >
              Remover cartão
            </Button>
          ) : (
            <Button
              size="medium"
              variant="contained"
              color="primary"
              disabled={!isValid}
              onClick={handleSubmit(handleSalvarCartao)}
            >
              Salvar cartão
            </Button>
          )}
        </Box>
      </Centered>
    </Container>
  );
}

export default MeiosPagamento;
